export default __webpack_public_path__ + "static/media/neulogo.8a334759.png";